import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, unref as _unref } from "vue"

const _hoisted_1 = { class: "benefits-container" }
const _hoisted_2 = { class: "benefit-info" }
const _hoisted_3 = {
  key: 0,
  class: "benefit-tags"
}
const _hoisted_4 = { class: "coin-wrapper" }
const _hoisted_5 = { class: "benefit-amount" }
const _hoisted_6 = { class: "benefit-price" }
const _hoisted_7 = {
  key: 1,
  class: "benefit-tips"
}
const _hoisted_8 = { class: "tips-content" }
const _hoisted_9 = {
  key: 2,
  class: "benefit-extra"
}
const _hoisted_10 = ["onClick"]

import { throttle } from '@/utils/index'; // 引入throttle函数

import { ref, computed } from 'vue';
// 定义 emit 事件

export default /*@__PURE__*/_defineComponent({
  __name: 'benefitsPurchase',
  props: {
  type: {
    type: String,
    default: ''
  }
},
  emits: ['purchase'],
  setup(__props, { emit: __emit }) {

const emit = __emit;

let prop = __props
const benefits = [
  { amount: '3600', price: '36', buyLabel: '3600积分包' },
  // { amount: '8000', price: '80', buyLabel: '8000积分包' },
  { amount: '12000', price: '120', buyLabel: '12000积分包' },
  { amount: '25000', price: '250', buyLabel: '25000积分包' },
  { amount: '40000', price: '400', buyLabel: '40000积分包' },
  {
    amount: '111100', price: '1111', buyLabel: '双十一活动', isDouble11: true,
    tip: '更多活动详情请联系：18666356083',
    tips: ['高精升级活动']
  }
];
const handlePurchase = throttle((item, type) => {
  emit('purchase', item, type)
}, 300)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(benefits, (benefit, index) => {
      return _createElementVNode("div", {
        class: _normalizeClass(["benefit-card", { 'double11-card': benefit.isDouble11 }]),
        key: index
      }, [
        _createElementVNode("div", _hoisted_2, [
          (benefit.tips)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("span", {
                  class: _normalizeClass(["activity-tag", { 'double11-tag': benefit.isDouble11 }])
                }, _toDisplayString(benefit.tips[0]), 3)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_4, [
            _cache[0] || (_cache[0] = _createElementVNode("i", { class: "ri-coins-fill" }, null, -1)),
            _createElementVNode("span", _hoisted_5, _toDisplayString(benefit.buyLabel), 1)
          ]),
          _createElementVNode("span", _hoisted_6, "¥" + _toDisplayString(benefit.price), 1),
          (benefit.tip)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("div", _hoisted_8, [
                  _cache[1] || (_cache[1] = _createElementVNode("i", { class: "ri-gift-2-fill" }, null, -1)),
                  _createElementVNode("span", null, _toDisplayString(benefit.tip), 1)
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[2] || (_cache[2] = [
                _createElementVNode("div", { class: "extra-content" }, [
                  _createElementVNode("i", { class: "ri-shield-star-fill" }),
                  _createElementVNode("span", null, "积分在手探索更多")
                ], -1),
                _createElementVNode("div", { class: "extra-content" }, [
                  _createElementVNode("i", { class: "ri-24-hours-fill" }),
                  _createElementVNode("span", null, "即时到账")
                ], -1)
              ])))
        ]),
        _createElementVNode("button", {
          class: "purchase-button",
          onClick: ($event: any) => (_unref(handlePurchase)(benefit, __props.type))
        }, "立即购买", 8, _hoisted_10)
      ], 2)
    }), 64))
  ]))
}
}

})